import React, { Component, Fragment } from 'react';
import { Map, TileLayer, Marker, Popup } from 'react-leaflet'
import L from 'leaflet'
import 'leaflet-sprite/dist/leaflet.sprite.js';

// コンポーネント読み込み
import GetCurrentLocationButton from './GetCurrentLocationButton'
import Loading from './Loading'

const MyPopupMarker = ({ item, onClick, onClose }) => (
  <Marker position={item.position} icon={item.visited ? L.spriteIcon('green'): L.spriteIcon('red')} onClick={() => { onClick(item) }}>
    <Popup onClose={() => { onClose() }}>
      {item.name}
    </Popup>
  </Marker>
)

const MyMarkersList = ({ markers, onClick, onClose }) => {
  const items = markers.map((item) => (
    <MyPopupMarker key={item.key} item={item} onClick={onClick} onClose={onClose} />
  ))
  return <Fragment>{items}</Fragment>
}

class MyMap extends Component {
  constructor(props: Props) {
    // Initialize the viewport to the one provided in props
    super(props)
    this.state = {
      zoom: 11,
      cur_lat: null,
      cur_lng: null,
      hasLocation: false,
    }
    this.getCurrentLatLng = this.getCurrentLatLng.bind(this)
    this.setCurrentLatLng = this.setCurrentLatLng.bind(this)
  }

  componentDidMount() {
    // DOM描画と同時に現在地取得を開始する
    this.getCurrentLatLng()
  }

  // 現在地取得に失敗した場合の処理
  falseGetCurrentPosition(error) {
    alert("位置情報取得に失敗しました。");
  }

  // 現在地を取得したらステートに設定する
  setCurrentLatLng(position) {
    this.setState({
      cur_lat: position.coords.latitude,
      cur_lng: position.coords.longitude,
      hasLocation: true
    })
  }

  getCurrentLatLng() {
    this.setState({ hasLocation: false })
    navigator.geolocation.getCurrentPosition(this.setCurrentLatLng, this.falseGetCurrentPosition);
  }

  render() {
    let {cur_lat, cur_lng, hasLocation} = this.state
    let {setSelectedSpot, initSelectedSpot} = this.props
    // 現在地のマーカーを配置
    let curLoc_marker = hasLocation ? (
        <Marker position={{lat: cur_lat, lng: cur_lng}} >
            <Popup>
                <span>現在地</span>
            </Popup>
        </Marker>
      ) : null
    if (hasLocation) {
      return (
        <div className="MyMap">
          <Map
            center={{lat: cur_lat, lng: cur_lng}}
            zoom={this.props.zoom}
            style={this.props.style}>
              <TileLayer
                  attribution="&amp;copy <a href='http://osm.org/copyright'>OpenStreetMap</a> contributors"
                  url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
              />
            {curLoc_marker}
            <MyMarkersList markers={this.props.spotList ? this.props.spotList: null} onClick={setSelectedSpot} onClose={initSelectedSpot} />
          </Map>
          <GetCurrentLocationButton getCurrentLatLng={this.getCurrentLatLng} />
        </div>
      )
    } else {
      return (
        <div className="MyMap">
          <Loading />
        </div>
      )
    }
  }
}

export default MyMap;
